/**
 * Todos os workspaces do GeoServer (`aeroespacial` incluído) aceitam leitura
 * anônima hoje — confirmado direto no servidor via GetMap/GetFeatureInfo/
 * GetLegendGraphic sem nenhuma credencial. Por isso este módulo nunca envia
 * Authorization: nenhum workspace é tratado como protegido.
 *
 * Isso já foi diferente: existia aqui uma credencial de leitura (`REACT_APP_
 * GEOSERVER_RO_USER/PASSWORD`) só para `aeroespacial`. Ela foi removida
 * porque não bloqueava nada de fato (o GeoServer já respondia sem ela) e só
 * gerava um aviso de console sempre que a env var não estava configurada no
 * deploy — sem efeito funcional, mas confuso. As funções abaixo continuam
 * exportadas com a mesma assinatura para não exigir mudança nos chamadores;
 * se o GeoServer voltar a exigir autenticação em algum workspace, é aqui que
 * a lógica de novo entra.
 */

export function isProtectedWorkspace(_workspace?: string): boolean {
  return false;
}

export function geoServerAuthHeader(_workspace?: string): string | undefined {
  return undefined;
}

/** Mesma credencial no formato aceito por `fetch`/axios. */
export function geoServerAuthHeaders(
  _workspace?: string
): Record<string, string> {
  return {};
}

/** Extrai o workspace de uma URL do GeoServer (`/geoserver/<ws>/wms`). */
export function workspaceFromUrl(url?: string): string | undefined {
  if (!url) return undefined;
  const match = url.match(/\/geoserver\/([^/?#]+)\//);
  return match?.[1];
}
